module.exports = __webpack_public_path__ + "img/20200613_092951.5ec33a03.jpg";